var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (!_vm.hidden)?_c('a',{staticClass:"w-tab",class:{active: _vm.active, disabled: _vm.disabled},attrs:{"disabled":_vm.disabled},on:{"click":function($event){$event.preventDefault();return _vm.onClick()}}},[_vm._t("default"),_c('div',{staticClass:"underline",class:{shown:_vm.active}})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }